/** A stage's icon box; the detail and live rows inset past it to line up with the title. */
export const PROCESSING_ICON_SIZE = '16px';
